<template>
  <div>
    <!--option说明  -->
    <baseBreadcrumb :page="$t('message.optionDescription')" :menu="$t('message.operationAndMaintenance')" />
    <div class="option" v-show="!iSoptionStore">

      <div class="body">
        <div class="search">
          <div class="btn">
            <!-- 创建大分类 -->
            <el-button type="success" @click="addACategory">
              {{ $t('message.createMajorCategory') }}
            </el-button>
            <!-- 创建option说明 -->
            <el-button type="success" @click="createOptionDescription">
              {{ $t('message.createOptionDescription') }}
            </el-button>
          </div>
        </div>
        <!-- 列表 -->
        <div class="table">
          <div class="item" v-for="(item, index) in tableData" :key="index">
            <div class="head">
              <!-- 排序 -->
              <div class="sort items">
                {{ $t('message.sort') }}
              </div>
              <!-- 大分类名称 -->
              <div class="categoryName  items">
                {{ $t('message.majorCategoryName') }}
              </div>
              <!-- 分类说明 -->
              <div class="categoryName  items">
                {{ $t('message.categoryDescription') }}
              </div>
              <!-- 状态 -->
              <div class="sort items">
                {{ $t('message.status') }}
              </div>
              <!-- 操作 -->
              <div class="operation items">
                {{ $t('message.operation') }}
              </div>
            </div>
            <div class="content">
              <!-- 排序 -->
              <div class="sort items">
                {{ item.sort }}
              </div>
              <!-- 大分类名称 -->
              <div class="categoryName  items">
                {{ item.name }}
              </div>
              <!-- 分类说明 -->
              <div class="categoryName  items">
                <div v-html="item.desc"></div>
              </div>
              <!-- 状态 -->
              <div class="sort items">
                {{ item.status == 1 ? '显示' : '隐藏' }}
              </div>
              <!-- 操作 -->
              <div class="operation items">
                <i class="el-icon-edit-outline" @click="categoryEdit(item)"></i>
                <i class="el-icon-delete" @click="optionDescCategoryDelete(item.id)"></i>
              </div>
            </div>
            <ol v-if="item.web_option != false">
              <!-- 排序 -->
              <li class="flex05"> {{ $t('message.sort') }}</li>
              <!-- 项目名称 -->
              <li> {{ $t('message.projectName') }}</li>
              <!-- 问号图标说明 -->
              <li class="flex2"> {{ $t('message.questionMarkIconDescription') }}</li>
              <!-- 页面固定展示说明 -->
              <li class="flex2"> {{ $t('message.pageFixedDisplayDescription') }}</li>
              <!-- 普通会员收费说明 -->
              <li> {{ $t('message.regularMemberFeeDescription') }}</li>
              <!-- 定额会员收费说明 -->
              <li> {{ $t('message.fixedRateMemberFeeDescription') }}</li>
              <!-- SVIP收费说明 -->
              <li> {{ $t('message.svipFeeDescription') }}</li>
              <!-- option图片 -->
              <li> {{ $t('message.optionImage') }}</li>
              <!-- option视频 -->
              <li> {{ $t('message.optionVideo') }}</li>
              <!-- 状态 -->
              <li class="flex05"> {{ $t('message.status') }}</li>
              <!-- 操作 -->
              <li class="flex "> {{ $t('message.operation') }}</li>
            </ol>
            <ul v-for="(items, indexs) in item.web_option" :key="indexs">
              <!-- 排序 -->
              <li class="flex05"> {{ items.sort }}</li>
              <!-- 项目名称 -->
              <li> {{ items.name }}</li>
              <!-- 问号图标说明 -->
              <li class="flex2">
                <div v-html="items.icon_desc"></div>
              </li>
              <!-- 页面固定展示说明 -->
              <li class="flex2">
                <div v-html="items.fixed_desc"></div>
              </li>
              <!-- 普通会员收费说明 -->
              <li>
                <div v-html="items.normal_client_desc"></div>
              </li>
              <!-- 定额会员收费说明 -->
              <li>
                <div v-html="items.vip_client_desc"></div>
              </li>
              <!-- SVIP收费说明 -->
              <li>
                <div v-html="items.svip_client_desc"></div>
              </li>
              <!-- option图片 -->
              <li>
                <el-image style="width:128px;height: 72px;border-radius: 6px;" :src="items.option_pic"
                  :preview-src-list="[items.option_pic]">
                </el-image>
              </li>
              <!-- option视频 -->
              <li class="word-break"> {{ items.option_video }}</li>
              <!-- 状态 -->
              <li class="flex05"> {{ items.status == 1 ? '显示' : '隐藏' }}</li>
              <!-- 操作 -->
              <li class=" flex">
                <i class="el-icon-edit-outline" @click="editOptionDescription(items)"></i>
                <i class="el-icon-delete" @click="optionDescOptionDelete(items.id)"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 添加编辑类目 -->
      <createMajorCategory :isAdd="isAdd" ref="createMajorCategory" />
    </div>
    <!-- 添加option -->
    <optionStore :isAdd="isAdd" ref="optionStore" :tableData="tableData" v-show="iSoptionStore" />
  </div>
</template>
<script>
import createMajorCategory from './components/createMajorCategory'
import optionStore from './components/optionStore'
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    createMajorCategory,
    optionStore
  },
  data() {
    return {
      tableData: [],
      isAdd: true,
      iSoptionStore: false,
      content: '',
    };
  },
  created() {
    this.optionDescList()
  },
  methods: {
    optionDescList() {
      this.$api.siteConfiguration.optionDescList({ keyword: '' }).then(res => {
        this.tableData = res.data
      })
    },
    // 新增类目
    addACategory() {
      this.isAdd = true
      this.$refs.createMajorCategory.acceptData({
        name: '',
        sort: 0
      })
    },
    // 新增类目
    addACategory() {
      this.isAdd = true
      this.$refs.createMajorCategory.acceptData({
        name: '',
        sort: 0
      })
    },
    //修改类目
    categoryEdit(item) {
      this.isAdd = false
      let itemData = JSON.parse(JSON.stringify(item))
      itemData.status_type = itemData.status == 1 ? true : false
      this.$refs.createMajorCategory.acceptData(itemData)
    },
    //删除类目
    optionDescCategoryDelete(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.siteConfiguration.optionDescCategoryDelete({ id }).then(res => {
            this.$message.success(res.msg)
            this.optionDescList()
          })
        })
        .catch(() => { });
    },
    //创建option分类
    createOptionDescription() {
      this.isAdd = true
      this.iSoptionStore = true
      this.$refs.optionStore.acceptData({
      })
    },
    // 修改option分类
    editOptionDescription(item) {
      this.isAdd = false
      this.iSoptionStore = true
      let itemData = JSON.parse(JSON.stringify(item))
      itemData.status_type = itemData.status == 1 ? true : false
      this.$refs.optionStore.acceptData(itemData)
    },
    //删除问题
    optionDescOptionDelete(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.siteConfiguration.optionDescOptionDelete({ id }).then(res => {
            this.$message.success(res.msg)
            this.optionDescList()
          })
        })
        .catch(() => { });

    },

  }
}
</script>
<style lang='scss' scoped>
.search {
  margin: 0 0 20px 0;
  height: 40px;
  text-align: right;
}

.table {
  .item {
    &:nth-child(1) {
      border-top: 1px solid #ccc;
    }

    i {
      margin-left: 20px;
      font-size: 25px;
      cursor: pointer;

      &:hover {
        color: #b4272d;
      }

    }

    .head,
    .content {
      display: flex;
      background-color: #EDEFF4;
      border: 1px solid #ccc;
      border-top: 0;



      .items {
        text-align: center;
        padding: 10px 0;
        border-right: 1px solid #ccc;

        &:nth-last-child(1) {
          border: 0;
        }
      }

      .sort {
        flex: 0.5;
      }

      .categoryName {
        flex: 5.01;
      }

      .operation {
        flex: 1;
      }
    }

    .content {
      background-color: #fff;
      border-top: 0 !important;
    }

    ol {
      border: 1px solid #ccc;
      border-top: 0;
      text-align: center;
    }

    ul {
      border: 1px solid #ccc;
      border-top: 0;
      padding: 0;
    }

    li {
      border-right: 1px solid #ccc;
      padding: 10px 0;
      display: block;
      display: flex;
      justify-content: center;
      align-items: center;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex3 {
      flex: 1;
    }

    .flex2 {
      flex: 2;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex {
      display: flex;
      justify-content: center;
      align-items: center;

    }
  }

}
</style>